import { render, staticRenderFns } from "./DashboardFilterChip.vue?vue&type=template&id=2cf48de0"
import script from "./DashboardFilterChip.vue?vue&type=script&lang=js"
export * from "./DashboardFilterChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports